export const ActivityTypeEnum = {
    Learning: 1,
    Final: 2,
    Reflection: 3
}

export const ActivityTypeEnumText = {
    Learning: "Learning",
    Final: "Final",
    Reflection: "Reflection"
}